import { useCallback } from "react";
const defaultGetOptionDisabled = () => false;
function useGetOptionDisabled(props) {
  const {
    selectState: {
      props: { getOptionDisabled = defaultGetOptionDisabled }
    }
  } = props;
  return useCallback(
    (option) => {
      if (typeof option === "string" && option === "no-matches") return true;
      return getOptionDisabled?.(option) ?? false;
    },
    [getOptionDisabled]
  );
}
export {
  useGetOptionDisabled
};
//# sourceMappingURL=useGetOptionDisabled.js.map
